import React from 'react';
import { useIntl } from 'react-intl';
import { browserHistory } from 'react-router';

import { Typography, IconButton, Menu, MenuItem } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import messages from './KebabActionsMenu.messages';

export interface KebabActionsMenuProps {
  flowId: string;
  cardId: string;
  status: string;
  patientId: string;
  setDeleteDialogOpen: (value: boolean) => void;
  setFlowSessionDialogOpen: (value: boolean) => void;
}

const KebabActionsMenu: React.FunctionComponent<KebabActionsMenuProps> = ({
  flowId,
  cardId,
  status,
  patientId,
  setDeleteDialogOpen,
  setFlowSessionDialogOpen,
}) => {
  const { formatMessage } = useIntl();

  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleViewTranscript = () => {
    browserHistory.push(`/patients/${patientId}/lumabot-session/${flowId}`);
  };

  const handleViewChat = React.useCallback(() => {
    setAnchorEl(null);
    setFlowSessionDialogOpen(true);
  }, [setFlowSessionDialogOpen]);

  const handleDialogDeleteOpen = React.useCallback(() => {
    setAnchorEl(null);
    setDeleteDialogOpen(true);
  }, [setDeleteDialogOpen]);

  return (
    <>
      <IconButton
        color="primary"
        aria-label="Actions"
        aria-owns={anchorEl ? `actions-menu-${flowId}` : undefined}
        aria-haspopup="true"
        onClick={(event) => setAnchorEl(event.currentTarget)}
        data-lh-id={`${cardId}-options-button`}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu id="menu-appbar" anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        <MenuItem disabled={status === 'pending'} onClick={handleViewChat} data-lh-id={`${cardId}-view-li`}>
          <Typography>{formatMessage(messages.viewChat)}</Typography>
        </MenuItem>
        <MenuItem disabled={status === 'pending'} onClick={handleViewTranscript} data-lh-id={`${cardId}-view-li`}>
          <Typography>{formatMessage(messages.viewTranscript)}</Typography>
        </MenuItem>
        <MenuItem onClick={handleDialogDeleteOpen} data-lh-id={`${cardId}-delete-li`}>
          <Typography>{formatMessage(messages.delete)}</Typography>
        </MenuItem>
      </Menu>
    </>
  );
};

export default KebabActionsMenu;
